module.exports = __webpack_public_path__ + "img/home_icon_logo_default.1ef3c777.png";